import React, { useEffect } from "react";
import { connect } from "react-redux";
import { actions, getters } from "../model";
import { noop } from "utils/General";
import { Div, Text3 } from "components/Base";
import css from "./styles.scss";
import { withRouter } from "react-router";
import * as R from "ramda";
import Loading from "ui-kit/Loading";
import { getters as PortalHomeGetters } from "Portal/NewPortal/PortalHome/model";

const decorate = R.compose(
  connect(
    state => ({
      loading: getters.loading(state),
      useBlocks: getters.useBlocks(state),
      title: getters.title(state),
      subtitle: getters.subtitle(state),
      content: getters.content(state),
      blocks: getters.blocks(state),
      styles: PortalHomeGetters.styles(state)
    }),
    {
      init: actions.init,
      goHome: actions.goHome
    }
  ),
  withRouter
);

const Body = ({
  init = noop,
  goHome = noop,
  title,
  subtitle,
  content,
  useBlocks,
  blocks = [],
  params,
  loading,
  styles
}) => {
  useEffect(() => {
    init({ resourceId: params.resourceId });
  }, []);

  return (
    <Div
      style={{
        width: "100%",
        maxWidth: "800px",
        height: "100%"
      }}
    >
      <Div
        py={3}
        display="row.flex-start.center"
        color="#4263EB"
        bb={1}
        bc="#E7E6EA"
        onClick={goHome}
      >
        <i
          style={{ fontSize: "16px", color: styles.accent_color || "#4263EB" }}
          className="material-icons"
        >
          arrow_back
        </i>
        <Text3 bold ml={2} color={styles.accent_color || "#4263EB"}>
          Home
        </Text3>
      </Div>
      {loading ? <Loading /> : null}
      {!loading ? (
        !useBlocks ? (
          <>
            {title && title.length ? (
              <div className={css.title}>{title}</div>
            ) : null}
            {subtitle && subtitle.length ? (
              <div className={css.subtitle}>{subtitle}</div>
            ) : null}
            <div
              className={["lennd-wysiwyg-content", css.previewer].join(" ")}
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </>
        ) : (
          blocks.map((block, index) => (
            <div
              className={css.previewer}
              key={`wiki-page-block-${index}`}
              dangerouslySetInnerHTML={{ __html: block.value }}
            ></div>
          ))
        )
      ) : null}
    </Div>
  );
};

export default decorate(Body);
